var jQuery = window.jQuery; // TODO: require("jquery");

jQuery(document).ready(function($) {
  $('body').on('click', '.js-popup', function(evt) {
    evt.preventDefault();
    window.open(
      $(this).attr("href"),
      'popup-window',
      'height=600, width=600, toolbar=no, menubar=no, status=no'
    );
  });
});
